import { TabStyles } from '@tableau/widgets';
import { CommonStyles } from '../../../common/react/CommonStyles';
import { cssClass, divWithStyle } from '../../../style';

export const DIALOG_WIDTH: number = 500;

export function helpTextDiv(testId: string) {
  return divWithStyle(testId, '-help-text', {
    paddingTop: TabStyles.Spacing.DefaultSpace,
  });
}

export function buttonContainerDiv(testId: string) {
  return divWithStyle(testId, '-button-container', {
    paddingTop: TabStyles.Spacing.DefaultSpace,
    float: 'right'
  });
}

export function inputHintDiv(testId: string) {
  return divWithStyle(testId, '-input-hint-text', {
    paddingTop: TabStyles.Spacing.DefaultSpace,
    paddingBottom: TabStyles.Spacing.DefaultSpace,
    fontSize: TabStyles.Typography.Sizing.Tiny,
    color: TabStyles.Typography.Color.PrimaryLight,
  });
}

export function textAreaCssClass(testId: string, height: number) {
  return cssClass(testId, 'editableMessage', {
    resize: 'none',
    boxSizing: 'border-box',
    width: '100%',
    height: height,
    fontSize: TabStyles.Typography.Sizing.Default,
    fontFamily: CommonStyles.Fonts.BodyFont,
    outline: 'none',
    marginBottom: TabStyles.Spacing.MediumSpace,
    padding: TabStyles.Spacing.DefaultSpace,
  });
}

export const cancelButtonStyle: React.CSSProperties = {
  marginRight: TabStyles.Spacing.MediumSpace,
};

export const buttonStyleSubmitting: React.CSSProperties = {
  verticalAlign: 'sub',
};

export const dialogBodyStyle: React.CSSProperties = {
  paddingTop: TabStyles.Spacing.MediumSpace,
  paddingBottom: TabStyles.Spacing.MediumSpace,
};

export const overLimitCounter: React.CSSProperties = {
  color: TabStyles.Colors.AttentionLight
};
